module.exports = __webpack_public_path__ + "static/james-3090b7b5fde60dea5d9b7d26b3b4f5d6.jpeg";